import React, { useEffect, useMemo } from 'react';
import { BsExclamationCircle } from 'react-icons/bs';
import { useDispatch, useSelector } from 'react-redux';
import { Box, HStack, Icon, Text } from '@chakra-ui/react';
import PropTypes from 'prop-types';

import { CypressIds } from '../../../constants/cypressIds';
import colors from '../../../styles/theme/foundation/colors';
import CertificateCreationBlueprintType from '../../../types/CertificateCreationBlueprintType';

import PolicyFormGenerator from './PolicyFormGenerator';

const EditPolicyModal = ({
  blueprint,
  company,
  policyType,
  submitFunction,
  cancelFunction,
  policy = null,
  showWarningMessage = false
}) => {
  const dispatch = useDispatch();
  const blueprintCompany = useSelector(blueprint.selectCompany);

  useEffect(() => {
    if (!blueprintCompany) {
      dispatch(blueprint.setCompany(company));
    }
  }, [company]);

  const policyOwner = useMemo(() => {
    const firstName = policy?.owner?.userFirstName;
    const lastName = policy?.owner?.userLastName;
    const email = policy?.owner?.userEmail;
    const agency = policy?.agency;

    let name = null;

    if (firstName && lastName) {
      name = `${firstName} ${lastName}`;
    } else if (firstName && !lastName) {
      name = firstName;
    } else if (!firstName && lastName) {
      name = lastName;
    }

    return {
      name,
      agency,
      email
    };
  }, [policy]);

  return (
    <Box>
      {showWarningMessage && (
        <Box data-cy={CypressIds.policyUpdateModalAgentUpdateWarning}>
          <HStack alignItems="flex-start" mb={4}>
            <Icon
              as={BsExclamationCircle}
              boxSize="24px"
              color={colors.caution.primary['600']}
            />
            <Text>This policy was uploaded by someone outside of your company.  When this policy is modified, PINS will send an email notification to the policy owner.</Text>
          </HStack>

          <Box textAlign="left">
            {policyOwner?.name && (
              <Text>
                <span style={{ fontWeight: '600' }}>Name: </span>
                {`${policyOwner?.name}`}
              </Text>
            )}
            <Text>
              <span style={{ fontWeight: '600' }}>Email: </span>
              {policyOwner?.email}
            </Text>
            {policyOwner?.agency?.name && (
            <Text>
              <span style={{ fontWeight: '600' }}>Agency: </span>
              {`${policyOwner?.agency?.name}`}
            </Text>
            )}
            {policyOwner?.agency && (<Text>{policyOwner?.agency}</Text>)}
          </Box>
        </Box>
      )}
      <PolicyFormGenerator
        blueprint={blueprint}
        formName="editPolicyData"
        policy={policy}
        policyType={policyType}
        secondaryButtonLabel="Cancel"
        secondaryFunction={() => cancelFunction()}
        submitFunction={data => submitFunction(data)}
        submitLabel="Save Policy"
      />
    </Box>
  );
};

EditPolicyModal.propTypes = {
  blueprint: CertificateCreationBlueprintType,
  company: PropTypes.shape({}).isRequired,
  policyType: PropTypes.shape({}).isRequired,
  policy: PropTypes.shape({}),
  submitFunction: PropTypes.func,
  cancelFunction: PropTypes.func,
  showWarningMessage: PropTypes.bool
};

export default EditPolicyModal;
